import { usePagination, useSorting } from "@/hooks";
import { GetNetworkParams } from "@/redux/apis/network/types";

export const useGetNetworkParams = (status?: string[], defaultSort?: { sort: string; direction: "asc" | "desc" }) => {
  const { page, pageSize } = usePagination();
  const { sortKey, direction } = useSorting(defaultSort);

  const params: GetNetworkParams = {
    page,
    page_size: pageSize,
    sort: sortKey,
    direction,
    status,
  };

  return { params, page, pageSize, sort: sortKey, direction };
};
